// extracted by mini-css-extract-plugin
module.exports = {"createFolderWindow":"createFolderWindow__XU93Y","content":"content__LR0GW","actions":"actions__xQmpK","uniqueFolderNameError":"uniqueFolderNameError__-EPnf"};